module.exports = __webpack_public_path__ + "img/void-light.6999fbce.svg";